/* Carveluna — interactividad propia (vanilla, sin librerías) */
(function () {
  // Cada sección enlaza este archivo: que solo se inicie una vez por página
  if (window.__mtIniciado) return;
  window.__mtIniciado = true;
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal, [data-mt-observar]');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { if (!el.classList.contains('mt-visible')) io.observe(el); });

    // Red de seguridad: nada se queda escondido aunque el observador falle
    var ultimo = 0;
    function revisar() {
      ultimo = Date.now();
      var alto = window.innerHeight || document.documentElement.clientHeight;
      els.forEach(function (el) {
        if (el.classList.contains('mt-visible')) return;
        var r = el.getBoundingClientRect();
        if (r.top < alto && r.bottom > 0) { el.classList.add('mt-visible'); io.unobserve(el); }
      });
    }
    window.addEventListener('scroll', function () { if (Date.now() - ultimo > 120) revisar(); }, { passive: true });
    window.addEventListener('scrollend', revisar);
    window.addEventListener('resize', revisar);
    var vigia = setInterval(function () {
      revisar();
      var quedan = false;
      els.forEach(function (el) { if (!el.classList.contains('mt-visible')) quedan = true; });
      if (!quedan) clearInterval(vigia);
    }, 700);
  }

  function initComparador() {
    document.querySelectorAll('[data-mt-comparador]').forEach(function (visor) {
      if (visor.dataset.mtListo) return;
      visor.dataset.mtListo = '1';
      var rango = visor.querySelector('.mt-comp__rango');
      if (!rango) return;
      var aplicar = function () { visor.style.setProperty('--pos', rango.value + '%'); };
      rango.addEventListener('input', aplicar);
      aplicar();
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (gal) {
      if (gal.dataset.mtListo) return;
      gal.dataset.mtListo = '1';
      var principal = gal.querySelector('.mt-pp__principal img');
      gal.querySelectorAll('.mt-pp__mini').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = btn.dataset.src;
            principal.srcset = '';
            principal.alt = btn.dataset.alt || '';
            principal.style.opacity = '1';
          }, 180);
          gal.querySelectorAll('.mt-pp__mini').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
        });
      });
    });
  }

  function formatoDinero(centavos, formato) {
    var valor = (centavos / 100).toFixed(2);
    var partes = valor.split('.');
    var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var conDec = miles + '.' + partes[1];
    return (formato || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, miles)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conDec.replace('.', '|').replace(/,/g, '.').replace('|', ','))
      .replace(/\{\{\s*amount\s*\}\}/, conDec);
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (raiz) {
      if (raiz.dataset.mtListo) return;
      raiz.dataset.mtListo = '1';
      var datos = raiz.querySelector('script[data-mt-variantes]');
      var form = raiz.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var inputId = form.querySelector('input[name="id"]');
      var boton = form.querySelector('button[type="submit"]');
      var precio = raiz.querySelector('[data-mt-precio]');
      var tachado = raiz.querySelector('[data-mt-tachado]');
      var textoAgotado = boton ? boton.dataset.agotado : '';
      var textoComprar = boton ? boton.dataset.comprar : '';
      var formato = raiz.dataset.moneyFormat;

      // Cantidad
      var cant = raiz.querySelector('.mt-pp__cantidad input');
      raiz.querySelectorAll('[data-mt-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          v = Math.max(1, v + parseInt(b.dataset.mtCant, 10));
          cant.value = v;
        });
      });

      // Variantes
      if (datos) {
        var variantes = JSON.parse(datos.textContent);
        raiz.querySelectorAll('.mt-pp__opcion input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var elegidas = [];
            raiz.querySelectorAll('.mt-pp__opcion').forEach(function (fs) {
              var c = fs.querySelector('input:checked');
              elegidas.push(c ? c.value : null);
            });
            var v = variantes.find(function (x) {
              return x.options.every(function (o, i) { return o === elegidas[i]; });
            });
            if (!v) return;
            inputId.value = v.id;
            if (precio) precio.textContent = formatoDinero(v.price, formato);
            if (tachado) {
              if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = formatoDinero(v.compare_at_price, formato); tachado.hidden = false; }
              else { tachado.hidden = true; }
            }
            if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? textoComprar : textoAgotado; }
            var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
          });
        });
      }

      // Envío AJAX al carrito de Dawn (con respaldo al envío normal)
      form.addEventListener('submit', function (ev) {
        var cartNotif = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!window.fetch || !cartNotif || typeof cartNotif.renderContents !== 'function') return;
        ev.preventDefault();
        var err = raiz.querySelector('.mt-pp__error');
        if (err) err.hidden = true;
        boton.disabled = true;
        var fd = new FormData(form);
        fd.append('sections', cartNotif.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        cartNotif.setActiveElement && cartNotif.setActiveElement(document.activeElement);
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) {
            if (err) { err.textContent = res.description || res.message; err.hidden = false; }
            return;
          }
          cartNotif.renderContents(res);
          if (cartNotif.classList.contains('is-empty')) cartNotif.classList.remove('is-empty');
        }).catch(function () { form.submit(); }).finally(function () { boton.disabled = false; });
      });

      // Barra de compra fija en móvil
      var barra = raiz.querySelector('.mt-pp__barra-movil');
      if (barra && 'IntersectionObserver' in window && boton) {
        new IntersectionObserver(function (en) {
          barra.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(boton);
        var bb = barra.querySelector('button');
        if (bb) bb.addEventListener('click', function () { boton.click(); });
      }
    });
  }

  // Fotos de las reseñas de Judge.me en la portada: su cargador diferido no las activa ahí
  function initFotosResenas() {
    var activar = function () {
      document.querySelectorAll('.mt-resenas-judgeme img[data-src]').forEach(function (img) {
        if (!img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));
        img.addEventListener('load', function () {
          var a = img.closest('.jdgm--loading');
          if (a) a.classList.remove('jdgm--loading');
        }, { once: true });
        if (img.complete && img.naturalWidth) {
          var a = img.closest('.jdgm--loading');
          if (a) a.classList.remove('jdgm--loading');
        }
      });
    };
    if (!document.querySelector('.mt-resenas-judgeme')) return;
    activar();
    setTimeout(activar, 1500);
    setTimeout(activar, 4000);
    document.addEventListener('click', function (e) {
      if (e.target.closest('.mt-resenas-judgeme .jdgm-paginate, .mt-resenas-judgeme [class*=paginate]')) setTimeout(activar, 1200);
    });
  }

  function iniciar() { initReveal(); initComparador(); initGaleria(); initProducto(); initFotosResenas(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
